import { unmask, numberUnmask } from 'utils/unmask';
import { removeSpace } from 'utils/masks';
import phoneNumbers from 'utils/blockedPhones';
import blokingEmails from 'utils/blockedEmails';

export default {
  firstName: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  lastName: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  phoneNumber: [{
    rule: 'required',
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }

      return (
        numberUnmask(input).length < 10 ||
        phoneNumbers.indexOf(input || '') !== -1 ||
        (input && input.charAt(1) === '0') ||
        (input && input.charAt(1) === '1') ||
        (input && input.substring(6) === '000-0000')
      ) ? 'Phone number is not valid' : true;
    },
  }],
  email: [
    'email',
    {
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }

        return blokingEmails.includes(`${input}`.toLowerCase()) ? 'Email is not valid' : true;
      },
    },
  ],
  monthlySavingsAmount: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  totalDebtAmount: [
    {
      rule: 'required',
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }
        return Number(unmask(input)) < 1000 || Number(unmask(input)) > 50000 ? 'Total Debt Amount not in range' : true;
      },
    },
  ],
  customerDedicatedAccountBalance: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  ClientId: [{
    rule: 'required',
    error: 'The input field is required',
  }],
  monthsLeft: [{
    rule: 'integer',
    error: 'The input field is required',
    isValid: (input) => {
      if (!input || removeSpace(input).length === 0) {
        return 'The input field is required';
      }
    },
  }],
};



// WEBPACK FOOTER //
// ./src/containers/pages/EmailApp/schema.js